import React from "react";

const Header = (props) => {
    return (
        <div style={{borderBottomStyle:'solid', borderBottomWidth:'2px', borderBottomColor: '#0C3653'}}>
            <h3> {props.title} </h3>
        </div>
    );
}

export default Header